import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
  selector: 'app-custom-expandable',
  templateUrl: './custom-expandable.component.html',
  styleUrls: ['./custom-expandable.component.scss']
})
export class CustomExpandableComponent implements OnInit, ICellRendererAngularComp{

  
  registerRowDragger: (rowDraggerElement: HTMLElement, dragStartPixels?: number, value?: string, suppressVisibilityChange?: boolean) => void;
  show: boolean = false;
  showSics: boolean = false;
  message: any;
  params: any;
  currentTab = ''
  listLength
  
voucherDetails:any[] =[];
manufacturingProcessDetails:any[] =[];
  agInit(params: any): void 
  {
    this.params = params;
    let copyData:any= this.params?.data?.paymentList==undefined?this.params?.data?.receiptList : this.params?.data?.paymentList;
    this.voucherDetails = JSON.parse(JSON.stringify(copyData));
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return true;
  }

  ngOnInit(): void
  {
  }

  getResponse($event) 
  {
    this.message = $event;
  }

  clickIcon() 
  {
    this.show = !this.show;
  }
  clickSicsIcon()
  {
    this.showSics = !this.showSics;
  }
}
